import React from 'react'
import { Routes } from '../constants';

import ManageDraft from '../pages/private/ManageDraft';
import DeletedCollections from '../pages/private/DeletedCollection';
import ManageDeleted from '../pages/private/DeletedCollection/DeletedCollection';
import AdminNotifications from "../pages/private/AdminNotifications";
import ManageCollection from "../pages/private/ManageCollection";
import ManageCollections from "../pages/private/ManageCollections";
import MintCalendars from "../pages/private/MintCalendar";
import MintCalendar from "../pages/private/MintCalendar/MintCalender";
import AdminFeaturedCollection from "../pages/private/AdminFeaturedCollection";
import ManageFeatured from '../pages/private/AdminFeaturedCollection/featured';
import DeleteListing from '../pages/private/DeleteLisitng';
import Courses from '../pages/private/Courses/courses';
import Course from '../pages/private/Courses/course';
import Rewards from '../pages/private/Rewards';
import ManageReward from '../pages/private/Rewards/reward';
import Category from '../pages/private/Courses/category';
import SubCategory from '../pages/private/Courses/subcategory';
import Lesson from '../pages/private/Courses/lesson';
import FeaturedCourses from '../pages/private/FeaturedCourses';
import WhitelistCommunities from '../pages/private/WhitelistCommunities';
import TelegramMessage from '../pages/private/Telegram/message';
import TelegramMessages from '../pages/private/Telegram/messages';
import Telegram from '../pages/private/Telegram';
import WhitelistManagement from '../pages/private/WhitelistManagement';
import BotsControl from '../pages/private/BotsControl';
import AddTelegramUser from '../pages/private/AddTelegramUser';
import UserManagement from '../pages/private/UserManagement';

export const routes = [
    { path: Routes.DASHBOARD, component: ManageCollections, public: false, exact: true },
    { path: Routes.ADMIN_NOTIFICATIONS, component: AdminNotifications, public: false, exact: true },
    { path: Routes.FEATURED_COLLECTION, component: AdminFeaturedCollection, public: false, exact: true },
    { path: Routes.FEATURED_COURSES, component: FeaturedCourses, public: false, exact: true },
    { path: Routes.COURSES_CATEGORY, component: Category, public: false, exact: true },
    { path: `${Routes.COURSES_CATEGORY}/:category/sub-category`, component: SubCategory, public: false, exact: true },
    { path: `${Routes.COURSES_CATEGORY}/:category/sub-category/:sub/courses`, component: Courses, public: false, exact: true },
    { path: `${Routes.COURSES_CATEGORY}/:category/sub-category/:sub/courses/manage`, component: Course, public: false, exact: true },
    { path: `${Routes.COURSES_CATEGORY}/:category/sub-category/:sub/courses/manage/:course/lesson`, component: Lesson, public: false, exact: true },
    { path: `${Routes.ALL_COURSES}/:course`, component: Course, public: false, exact: true },
    { path: Routes.REWARDS, component: Rewards, public: false, exact: true },
    { path: `${Routes.REWARDS}/:reward`, component: ManageReward, public: false, exact: true },
    { path: `${Routes.MANAGE_FEATURED}/:featured?`, component: ManageFeatured, public: false, exact: true },
    { path: `${Routes.MANAGE_DRAFT}/:collectionId?`, component: ManageDraft, public: false, exact: true },
    { path: `${Routes.MANAGE_DELETED}`, component: DeletedCollections, public: false, exact: true },
    { path: `${Routes.MANAGE_DELETED}/:collectionId`, component: ManageDeleted, public: false, exact: true },
    { path: `${Routes.MANAGE_COLLECTION}/:collectionId?/:state?`, component: ManageCollection, public: false, exact: true },
    { path: Routes.MANAGE_COLLECTIONS, component: ManageCollections, public: false, exact: true },
    { path: `${Routes.MINT_CALENDAR}/:collectionId?`, component: MintCalendar, public: false, exact: true },
    { path: Routes.MINT_CALENDARS, component: MintCalendars, public: false, exact: true },
    { path: Routes.DELETE_LISTING, component: DeleteListing, public: false, exact: true },
    { path: Routes.WHITELIST_PARTNER, component: WhitelistCommunities, public: false, exact: true },
    { path: Routes.WHITELIST_MANAGEMENT, component: WhitelistManagement, public: false, exact: true },
    { path: Routes.USER_MANAGEMENT, component: UserManagement, public: false, exact: true },
    { path: Routes.TELEGRAM, component: Telegram, public: false, exact: true },
    { path: Routes.TELEGRAM_MESSAGES, component: TelegramMessages, public: false, exact: true },
    { path: Routes.TELEGRAM_MESSAGE, component: TelegramMessage, public: false, exact: true },
    { path: Routes.BOTS_CONTROL, component: BotsControl, public: false, exact: true },
    { path: Routes.ADD_TELEGRAM_USER, component: AddTelegramUser, public: false, exact: true },
]